export const FETCH_ASSESSMENT_MESSAGES = 'FETCH_ASSESSMENT_MESSAGES';
export const UPDATE_PAGE_ASSESSMENT_MESSAGES =
  'UPDATE_PAGE_ASSESSMENT_MESSAGES';
